<template>
  <div class="multi-level-picker" v-clickoutside="handleClickOutside">
    <div
      class="multi-level-content"
      @click="changeModalVisible"
    >
      <div
        class="value"
        :class="{ 'active-value': activeValue }"
      >
        {{ activeValue || placeholder }}
      </div>
      <span
        class="iconfont iconchevron-down"
        :class="{ rotate: visible }"
      ></span>
    </div>
    <div
      v-if="visible"
      class="picker-options-content"
      @mouseleave="handleMouseLeave"
    >
      <div
        class="first-level-content"
        :style="activeIndex === -1 ? { borderRadius: '8px' } : {}"
      >
        <div
          v-for="(item, index) in list"
          class="picker-item"
          :class="{ active: activeIndex === index }"
          :key="index"
          @mouseenter.stop="handleMouseEnter(index)"
          @click.stop="clickFirstLevelItem(item)"
        >
          <div class="picker-item-title">{{ item.title }}</div>
          <span v-if="isMultiLevel" class="iconfont iconchevron-right"></span>
        </div>
      </div>
      <div
        v-if="pickerDetailData && isMultiLevel"
        class="other-picker-content"
      >
        <div class="title">
          {{ pickerDetailData.title }}
        </div>
        <div
          v-if="pickerDetailData.list && pickerDetailData.list.length"
          class="sub-picker-list"
        >
          <div
            v-for="(item, index) in pickerDetailData.list"
            class="sub-picker-item"
            :key="index"
          >
            <div class="sub-title">{{ item.title }}</div>
            <div class="children-list">
              <div
                v-for="(subItem, subIndex) in item.list"
                class="children-item"
                :class="{ 'active': subItem.title === activeValue }"
                :key="subIndex"
                @click="clickChildrenItem(subItem)"
              >
                {{ subItem.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clickoutside from "@/assets/js/clickoutside";
export default {
  name: 'MultiLevelPicker',
  props: {
    activeValue: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    isMultiLevel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: -1,
      visible: false,
    };
  },
  computed: {
    pickerDetailData() {
      return this.list[this.activeIndex];
    },
  },
  directives: {
    clickoutside,
  },
  methods: {
    handleMouseEnter(index) {
      this.activeIndex = index;
    },
    handleMouseLeave() {
      this.activeIndex = -1;
    },
    changeModalVisible() {
      this.visible = !this.visible;
    },
    handleClickOutside() {
      this.visible = false;
    },
    clickChildrenItem(item) {
      this.visible = false;
      this.$emit('confirm', item.title);
    },
    clickFirstLevelItem(item) {
      if (!this.isMultiLevel) {
        this.visible = false;
        this.$emit('confirm', item.title);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.multi-level-picker {
  position: relative;
  z-index: 20;
  .multi-level-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    width: 380px;
    height: 48px;
    border-radius: 8px;
    background: rgba($color: #fff, $alpha: 0.1);
    border: 1px solid transparent;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background: linear-gradient(90deg, #303336, #303336), linear-gradient(179.99998deg, #ff3d11, #ff9b19 191%);
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      border: 1px solid transparent;
    }
    .value {
      color: #9a9ca2;
      &.active-value {
        color: #fff;
      }
    }
    .iconfont {
      font-size: 22px;
      transition: all 0.3s;
      &.rotate {
        transform: rotate(180deg);
      }
    }
  }
  .picker-options-content {
    display: flex;
    align-items: center;
    position: absolute;
    top: 56px;
    left: 0;
    height: 244px;
    .first-level-content {
      width: 180px;
      height: 244px;
      border-radius: 8px 0 0 8px;
      background: #2f3336;
      padding: 8px 12px;
      box-sizing: border-box;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      .picker-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 40px;
        padding: 0 12px;
        box-sizing: border-box;
        color: #fff;
        cursor: pointer;
        border-radius: 6px;
        .iconfont {
          font-size: 22px;
        }
        &:hover,
        &.active {
          background-color: rgba($color: #ff6644, $alpha: 0.2);
          color: #ff6644;
          font-weight: 500;
        }
      }
    }
    .other-picker-content {
      width: 620px;
      height: 244px;
      background: #2f3336;
      border-radius: 0 8px 8px 0;
      padding: 16px;
      box-sizing: border-box;
      overflow-y: scroll;
      border-left: 1px solid #484e5c;
      &::-webkit-scrollbar {
        display: none;
      }
      .title {
        font-size: 16px;
        font-weight: 500;
      }
      .sub-picker-list {
        .sub-picker-item {
          display: flex;
          justify-content: space-between;
          padding-top: 16px;
          .sub-title {
            color: #fff;
            font-size: 14px;
          }
          .children-list {
            display: flex;
            flex-wrap: wrap;
            width: 458px;
            row-gap: 8px;
            column-gap: 20px;
            padding-bottom: 16px;
            border-bottom: 1px solid #484e5c;
            .children-item {
              font-size: 14px;
              color: #fff;
              cursor: pointer;
              &:hover,
              &.active {
                color: #ff6644;
              }
            }
          }
        }
      }
    }
  }
}
</style>
